import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      margin: 'auto',
    },
    cardHeader: {
      padding: theme.spacing(1, 2),
    },
    homeView: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      width: '100vw',
    },
    list: {
      width: '28vw',
      height: '50vh',
      backgroundColor: theme.palette.background.paper,
      overflow: 'auto',
    },
    button: {
      margin: theme.spacing(0.5, 0),
    },
    saveButton: {
      alignSelf: 'center',
      fontSize: '1.1em',
      fontWeight: 'bold',
      fontFamily: 'Montserrat',
      minHeight: '4vh',
      maxWidth: '20%',
      margin: '-20px 0 3vh 0',
    },
    text: {
      alignSelf: 'center',
      fontFamily: 'Montserrat',
      fontSize: '1em',
      marginBottom: '-25px',
      marginTop: '5px',
      textAlign: 'center',
      width: '50%',
    },
    title: {
      fontFamily: 'Montserrat',
      fontSize: '1.4em',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center',
    },
    image: {
      alignSelf: 'center',
      borderRadius: '10px',
      height: '2vw',
      margin: '82px 0 3vh',
      minHeight: 60,
      minWidth: 60,
      width: '2vw',
    },
  })
);
